import React from 'react';
import { NumericFormat } from 'react-number-format';

const CurrencyFormatter = ({ value, currency, textStlyes }) => {
  return (
    <>
      <NumericFormat
        value={value}
        displayType={'text'}
        decimalScale={2}
        allowNegative={true}
        fixedDecimalScale={true}
        thousandSeparator={true}
        prefix={`${currency ? currency : ''}`}
        renderText={(formattedValue) => (
          <p class={textStlyes}>{formattedValue}</p>
        )}
      />
    </>
  );
};

export default CurrencyFormatter;

export const NumberFormatteredPecentage = ({
  value,
  symbol,
  textStlyes,
  decimal = 2,
}) => {
  return (
    <>
      <NumericFormat
        value={value}
        displayType={'text'}
        decimalScale={decimal}
        allowNegative={true}
        fixedDecimalScale={true}
        thousandSeparator={true}
        suffix={`${symbol ? symbol : ''}`}
        renderText={(formattedValue) => (
          <p style={textStlyes}>{formattedValue}</p>
        )}
      />
    </>
  );
};

export const NumberFormatteredWithoutSymbols = ({
  value,
  textStlyes,
  decimal = 2,
}) => {
  return (
    <>
      <NumericFormat
        value={value}
        displayType={'text'}
        decimalScale={decimal}
        allowNegative={true}
        fixedDecimalScale={true}
        thousandSeparator={true}
        suffix={``}
        renderText={(formattedValue) => (
          <p style={textStlyes}>{formattedValue}</p>
        )}
      />
    </>
  );
};
